import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section>
      <h1>Page not found</h1>
      <p>The page you requested could not be found.</p>
      <Link to="/">Return to the homepage</Link>
    </section>
  );
}
